<template>
  <div
    :id="categoryMappingId"
    class="select_item item_box"
  >
    <div class="item_header ">
      <span class="form_element-radio">
        <input
          :id="packInfo.pack_cd"
          v-model="radioSelected"
          type="radio"
          name="recomend_pack"
          :value="packInfo.pack_cd"
          @change="onRadioChange"
        >
        <label
          :for="packInfo.pack_cd"
          class="focus"
        >{{ packInfo.name }}</label>
      </span>
      <div>
        <!-- <p><em>1일 총 {{ totalPhilsPerDay }}</em>정/캡슐
          <span>(총{{ totalPockets }}포)</span></p> -->
        <p
          class="ell"
        >{{ packItemsTextSummary }}</p>
      </div>
    </div>
    <div
      class="item_foot"
      :class="activeState"
    >
      <p class="total_price">
        <em><mpn-label-number :amount="packInfo.packPrice" /></em> 원
      </p>
      <span
        class="small_text"
      >PV/BV <mpn-label-number
        :amount="packInfo.packPv"
      /> / <mpn-label-number :amount="packInfo.packBv" /></span>
      <button
        type="button"
        class="btn_open"
        @click="showDetail"
      >
        자세히 보기
      </button>
    </div>
    <template v-if="isShowDetail">
      <recommend-item-detail
        :total-phils-per-day="totalPhilsPerDay"
        :total-pockets="totalPockets"
        :pocket-details="packDetails"
        :pack-explain="packInfo.pack_explain"
      />
    </template>
  </div>
</template>

<script>
import { log } from '@/utils/common';
import { DOUBLE_X_SKU } from '@/utils/constants';
import { mapGetters } from 'vuex';
import productHelpers from '@/utils/helpers/product';
import RecommendItemDetail from './RecommendItemDetail.vue';

export default {
  name: 'RecommendItem',
  components: {
    RecommendItemDetail,
  },
  props: {
    packInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isShowDetail: false,
      radioSelected: null,
      activeState: '',
      packDetails: [],
    };
  },
  computed: {
    ...mapGetters({
      recommendationCategories: 'recommendation/recommendationCategories',
    }),
    totalPockets() {
      return this.packInfo.take_days * this.packInfo.take_cnt;
    },
    totalTablets() {
      return this.packInfo.pack_detail
        .reduce((acc, n) => acc + n.dose_detail.reduce((acc2, n2) => acc2 + n2.dose_cnt, 0), 0);
    },
    totalPhilsPerDay() {
      return this.packInfo.pack_detail.reduce(
        (acc, n) => acc + productHelpers
          .parseSeq(n.doseSeqs)
          .reduce((acc2, x) => acc2 + (n.item_sku === DOUBLE_X_SKU ? x * 3 : x),
            0),
        0,
      );
    },
    categoryMappingId() {
      return this.recommendationCategories
        .find((n) => n.packCategoryCode === this.packInfo.pack_category_cd)
        .packMappingName;
    },
    packItemsTextSummary() {
      const arr = [];
      this.packDetails.forEach((n) => {
        n.items.forEach((nn) => {
          arr.push(nn.item_name);
        });
      });
      const result = [...new Set(arr)];
      return result.join(',');
    },

  },
  watch: {
    packInfo() {
      log('RecommendItem::watch.packInfo');
      this.initState();
    },
  },

  created() {
    this.initState();
  },
  methods: {
    initState() {
      this.packDetails = JSON.parse(JSON.stringify(this.packInfo.components));
      switch (this.packInfo.maxDoseCount) {
        case 1:
          this.packDetails[0].takingTime = '하루';
          break;
        case 2:
          this.packDetails[0].takingTime = '오전';
          this.packDetails[1].takingTime = '오후';
          break;
        case 3:
          this.packDetails[0].takingTime = '아침';
          this.packDetails[1].takingTime = '점심';
          this.packDetails[2].takingTime = '저녁';
          break;
        default:
      }
    },
    showDetail() {
      this.isShowDetail = !this.isShowDetail;
      if (this.activeState === 'active') {
        this.activeState = '';
      } else {
        this.activeState = 'active';
      }
    },
    onRadioChange() {
      if (this.radioSelected !== null) {
        this.$emit('selected', this.packInfo.pack_cd);
      }
    },
    resetSelection() {
      this.radioSelected = false;
    },

  },
};
</script>



// WEBPACK FOOTER //
// src/components/recommendation/RecommendItem.vue